import { Component, EventEmitter, OnInit, Inject } from '@angular/core';

import { ApiService } from 'src/app/config/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-modal',
  templateUrl: './cookie-modal.component.html',
  styleUrls: ['./cookie-modal.component.scss'],
  providers: [ApiService]
})
export class CookieModalComponent implements OnInit {

  hideEvent: EventEmitter<boolean> = new EventEmitter();
  pages = ['1','2','3']
  pageToShow = '2';
  constructor(
    private _apiService: ApiService,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {

  }

  hideModal() {
    this.hideEvent.emit(true);
  }

  acceptCookies(res){
    let cookies;
    if(res){
      cookies = {
        accepted : true,
      }
    }
    else{
      cookies = {
        accepted : false,
      }
    }
    localStorage.setItem('cookiePolicy', JSON.stringify(cookies));
    this.hideModal();
  }

}
